module.exports = __webpack_public_path__ + "static/img/煤仓上口堆煤识别.700f593a.png";